import React, { useEffect, useState } from "react"
import { Cidade, ClientesAttributes, ItensVendas, RelatorioConsultaVendas } from "../../../Utils/Types"
import Logo4 from '../../../assets/imagens/Logo4.png'
import moment from "moment"
import { ClientesService } from "../../Clientes/ClientesService"
import { Funcoes } from "../../../Utils/Funcoes"


export type Props = {
    visible: boolean,
    dadosVenda?: ItensVendas[],
    dadosCliente?: any,
    descricoesFiltradas?: any,
    parcelamentos?: any,
    dadosDesconto?: any,
    dadosReimpressao?: RelatorioConsultaVendas[],
    reciboReimprimido?: boolean
    closeModalEvent: () => void
}

export const ReportVendaFinalizadaBobina = ({ visible, dadosVenda, dadosCliente, descricoesFiltradas, parcelamentos, dadosDesconto, dadosReimpressao, reciboReimprimido, closeModalEvent }: Props) => {

    const [dadosEmpresa, setDadosEmpresa] = useState<any>()
    //const [dadosDoCliente, setDadosDoCliente] = useState<ClientesAttributes>()
    //const [nomeCidade, setNomeCidade] = useState<Cidade>()
    //const [loading, setLoading] = useState(true)

    useEffect(() => {
        setDadosEmpresa(Funcoes.GetDadosEmpresa())
    }, []);

    useEffect(() => {

        if (visible) {

            //getClientes()

            let modal = document.getElementById('modal_vendas_report_bobina')
            let modalContent = document.getElementById('modal_content_vendas_report_bobina')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-2000px]')
                    modalContent.classList.add('mt-2')
                }
            }

            const printContent = document.getElementById('modal_content_vendas_report_bobina');

            if (printContent) {
                // Abrir uma nova aba
                const printWindow = window.open('novaJanela', 'width=800,height=400', '_blank');

                if (printWindow) {
                    // Escrever o conteúdo na nova aba
                    printWindow.document.open();
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Impressão</title>
                                                        <script src="https://cdn.tailwindcss.com"></script>
                                                    </head>
                                                    <body>${printContent.innerHTML}</body>
                                                </html>
                                            `);
                    printWindow.document.close();

                    if (typeof closeModalEvent === 'function') {
                        closeModalEvent();
                    }

                } else {
                    console.error("Não foi possível abrir uma nova aba para impressão.");
                }
            } else {
                console.error("Elemento do modal não encontrado.");
            }


        } else {

            let modal = document.getElementById('modal_vendas_report_bobina');
            let modalContent = document.getElementById('modal_content_vendas_report_bobina');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-2000px]');
                    modalContent.classList.remove('mt-2');
                }
            }

            //setNomeCidade(undefined)
            //setLoading(true)
        }

    }, [visible])

    /*
    useEffect(() => {
        if (!loading) {
            //window.print();
            //setLoading(true)

            const timer = setTimeout(() => {

                //closeModalEvent();
                clearTimeout(timer)

            }, 100)

        }
    }, [loading]);

    useEffect(() => {
        if (dadosEmpresa) {
            setLoading(false)
        }
    }, [dadosEmpresa]);
    */

    /*
    useEffect(() => {
        if (dadosDoCliente) {

            setNomeCidade(dadosDoCliente.cidades.find((item: any) => item.id === dadosDoCliente.cliente.id_cidade));
            setLoading(false)

        }
    }, [dadosDoCliente]);
    
    const getClientes = async () => {
        const cliente = await ClientesService.GetAttributes(dadosCliente?.id_consumidor || (dadosReimpressao && dadosReimpressao[0].id_cliente))
        setDadosDoCliente(cliente)
    }

    const somarTotalVenda = (dadosVenda: ItensVendas[]) => {
        return dadosVenda.reduce((acumulador, item) => acumulador + item.vl_tot, 0);
    }

    let valorTotal = somarTotalVenda(dadosVenda || [])
    */

    return (

        <div id="modal_vendas_report_bobina" style={{ visibility: "hidden" }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_vendas_report_bobina" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'auto', borderRadius: '0.5rem', marginTop: '-2000px', transition: 'all 0.3s' }}>

                <div style={{ width: "80mm", minHeight: "500px", height: "auto", backgroundColor: "white", paddingLeft: '0.25rem', paddingRight: '0.25rem', padding: '0.5rem' }}>

                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "14px", padding: "4px", textAlign: "center" }}>
                            <span style={{ marginBottom: '3px' }}>{dadosEmpresa?.razao || ''}</span>
                            <span style={{ marginBottom: '3px' }}>{'CNPJ: ' + Funcoes.FormatDoc(dadosEmpresa?.cnpj_cpf)}</span>
                            <span style={{ marginBottom: '3px' }}>{(dadosEmpresa?.endereco || '') + ", " + (dadosEmpresa?.numero || '')}</span>
                            <span>{(dadosEmpresa?.cidade || '') + " - " + (dadosEmpresa?.bairro || '')}</span>
                        </div>
                    </div>

                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "12px", padding: "4px", textAlign: "center" }}>
                            <span>{"NAO E VALIDO COMO DOCUMENTO FISCAL"}</span>
                        </div>
                    </div>

                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "14px", padding: "4px", textAlign: "center" }}>
                            <span style={{ fontWeight: "bold" }}>{`${dadosReimpressao && dadosReimpressao[0]?.Crediario.length > 0 ? "VENDA A PRAZO" : "VENDA A VISTA"}`}</span>
                        </div>
                    </div>

                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "12px", padding: "4px" }}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "40%" }}>{`N° Pedido: ${dadosReimpressao ? dadosReimpressao[0]?.id || "" : ""}`}</span>
                                <span style={{ width: "60%", textAlign: "end" }}>{`Emissao: ${dadosReimpressao ? moment(dadosReimpressao[0]?.data_hora).format("DD/MM/YYYY HH:mm") : ""}`}</span>
                            </div>
                            <span style={{ width: "50%" }}>{`Vendedor: ${dadosReimpressao ? dadosReimpressao[0]?.name_user_venda || "" : ""}`}</span>
                        </div>
                    </div>

                    {dadosReimpressao && dadosReimpressao[0]?.id_cliente > 0 && (
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "12px", padding: "4px" }}>
                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Cliente......:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? dadosReimpressao[0]?.DadosCliente.nome || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Fantasia....:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? dadosReimpressao[0]?.DadosCliente.nome_fantasia || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Telefone...:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? Funcoes.FormatTelefone(dadosReimpressao[0]?.DadosCliente.contato.telefone) || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Endereço.:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? dadosReimpressao[0]?.DadosCliente.endereco || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Bairro........:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? dadosReimpressao[0]?.DadosCliente.bairro || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"Cidade......:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? dadosReimpressao[0]?.DadosCliente.nome_cidade || "" : ""}</span>
                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "25%" }}>{"CNPJ/CPF:"}</span>
                                <span style={{ width: "75%", paddingLeft: "1px" }}>{dadosReimpressao ? Funcoes.FormatDoc(dadosReimpressao[0]?.DadosCliente.cnpj_cpf) || "" : ""}</span>
                            </div>
                        </div>
                    )}

                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "12px", padding: "4px" }}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <span style={{ width: "100%", wordBreak: "break-all" }}>{`Obs: ${dadosReimpressao ? dadosReimpressao[0]?.observacao || "" : ""}`}</span>
                            </div>
                        </div>
                    </div>

                    <table style={{ marginTop: "4px", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ width: "15%", fontSize: "11px", textAlign: "start" }}>Codigo</th>
                                <th style={{ width: "30%", fontSize: "11px", textAlign: "start" }}>Descrição</th>
                                <th style={{ width: "15%", fontSize: "11px", textAlign: "end" }}>Qtde</th>
                                <th style={{ width: "20%", fontSize: "11px", textAlign: "end" }}>Unit</th>
                                <th style={{ width: "20%", fontSize: "11px", textAlign: "end" }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dadosReimpressao &&
                                dadosReimpressao[0]?.itens.map((item: any, index: any) => (
                                    <React.Fragment key={index}>
                                        <tr >
                                            <td style={{ width: "15%", fontSize: "11px", textAlign: "start", }}>{(item.cod_barra || '')}</td>
                                            <td style={{ width: "30%", fontSize: "11px", textAlign: "start", }}>{(item.desc_prod || '')}</td>
                                            <td style={{ width: "15%", fontSize: "11px", textAlign: "end", }}>{Funcoes.numberFormat(item.qtde || 0, 'decimal')}</td>
                                            <td style={{ width: "20%", fontSize: "11px", textAlign: "end", }}>{Funcoes.numberFormat(item.vl_unit || 0, 'decimal')}</td>
                                            <td style={{ width: "20%", fontSize: "11px", textAlign: "end", }}>{Funcoes.numberFormat(item.vl_tot || 0, 'decimal')}</td>
                                        </tr>
                                        {item.observacao && (
                                            <tr>
                                                <td colSpan={6} style={{ fontSize: '11px', textAlign: 'left', padding: '1px 3px 1px 3px', color: '#555' }}>
                                                    <strong>Obs:</strong> {item.observacao}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>

                                ))}
                        </tbody>
                    </table>


                    <div style={{ width: "100%" }}>
                        <div style={{ minHeight: '20px', height: "auto", width: "100%", border: "1px solid black", borderLeft: "0", borderRight: "0", borderTop: "0", display: "flex", flexDirection: "column", fontSize: "12px", }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span style={{ width: "5%", textAlign: "start", marginRight: "4px" }}>{'Desconto:'}</span>
                                    <span style={{ width: "5%", textAlign: "start", marginRight: "4px" }}>{'Troco:'}</span>
                                    <span style={{ width: "5%", textAlign: "start", marginRight: "4px" }}>{'Total:'}</span>
                                </div>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <span style={{ width: "auto", textAlign: "end" }}>
                                        {dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_desc, 'decimal') : ''}
                                    </span>
                                    <span style={{ width: "auto", textAlign: "end" }}>
                                        {dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_troco, 'decimal') : ''}
                                    </span>
                                    <span style={{ width: "auto", textAlign: "end" }}>
                                        {dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_bruto - dadosReimpressao[0]?.vl_desc, 'decimal') : ''}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: '0.25rem', width: '100%' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: '14px' }}>
                            <span>Formas de Pag.: </span>
                            {dadosReimpressao && dadosReimpressao[0]?.pagamentos.map((item: any, index: any) => (
                                <div key={index} style={{ textAlign: 'start', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>
                                    {(item.descricao || '') + '(' + Funcoes.numberFormat(item.valor, 'currency') + ')'}
                                </div>
                            ))}
                        </div>
                    </div>

                    {(dadosReimpressao && dadosReimpressao[0]?.Crediario.length > 0) && (
                        <table style={{ marginTop: '0.25rem', width: '100%' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '30%', fontSize: '12px', textAlign: 'left', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>Duplicata</th>
                                    <th style={{ width: '30%', fontSize: '12px', textAlign: 'left', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>Vencimento</th>
                                    <th style={{ width: '40%', fontSize: '12px', textAlign: 'right', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dadosReimpressao && dadosReimpressao[0]?.Crediario.map((item: any, index: any) => (
                                    <tr key={index}>
                                        <td style={{ width: '30%', fontSize: '12px', textAlign: 'left', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>{(item.serie || '')}</td>
                                        <td style={{ width: '30%', fontSize: '12px', textAlign: 'left', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>{(moment(item.data_vencimento).format("DD/MM/YYYY") || '')}</td>
                                        <td style={{ width: '40%', fontSize: '12px', textAlign: 'right', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>{Funcoes.numberFormat(item.valor || 0, 'decimal')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <div style={{ width: '100%', marginTop: '5rem' }}>
                        <div style={{ minHeight: '80px', height: 'auto', width: '100%', border: '1px solid black', borderLeft: 'none', borderRight: 'none', borderBottom: 'none', display: 'flex', flexDirection: 'column', fontSize: '14px', paddingTop: '0.25rem', paddingBottom: '0.25rem' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <span style={{ width: '100%', textAlign: 'center' }}>{'Ass. Cliente'}</span>
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '100%', marginTop: '1.25rem' }}>
                        <div style={{ minHeight: '80px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingTop: '0.25rem', paddingBottom: '0.25rem' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <span style={{ width: '100%' }}>{'Impressao: ' + moment(new Date()).format("DD/MM/YYYY HH:mm:ss")}</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    )

}